module.exports = __webpack_public_path__ + "img/Postmodernisme_Andre_kunstformer11.2f4d8cb4.jpg";